import {Controller} from "stimulus"
import MicroModal from "micromodal"

export default class extends Controller {
  static get targets() {
    return ["video"]
  }

  connect() {
    this.lazyLoad()
  }

  lazyLoad() {
    var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"))

    if ("IntersectionObserver" in window) {
      var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (video) {
          if (video.isIntersecting) {
            var videoSource = video.target.children[0]
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src
            }

            video.target.load()
            video.target.classList.remove("lazy")
            lazyVideoObserver.unobserve(video.target)
          }
        })
      })

      lazyVideos &&
        lazyVideos.forEach(function (lazyVideo) {
          lazyVideoObserver.observe(lazyVideo)
        })
    }
  }
}
